/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 目标语言代码。请从支持的语言列表中选择一个语言代码。
 */
export const PostTranslateTextToLang = {
  Sq: "sq",
  Ga: "ga",
  Et: "et",
  Ar: "ar",
  Am: "am",
  Az: "az",
  Be: "be",
  Bg: "bg",
  Eu: "eu",
  Is: "is",
  Pl: "pl",
  BsLatn: "bs-Latn",
  Fa: "fa",
  Da: "da",
  De: "de",
  Ru: "ru",
  Fr: "fr",
  Tl: "tl",
  Fi: "fi",
  Fy: "fy",
  Km: "km",
  Ka: "ka",
  Gu: "gu",
  Ht: "ht",
  Ko: "ko",
  Ha: "ha",
  Kk: "kk",
  Nl: "nl",
  Gl: "gl",
  Ca: "ca",
  Cs: "cs",
  Ky: "ky",
  Kn: "kn",
  Tlh: "tlh",
  Hr: "hr",
  Otq: "otq",
  Co: "co",
  Ku: "ku",
  La: "la",
  Lo: "lo",
  Lv: "lv",
  Lt: "lt",
  Ro: "ro",
  Lb: "lb",
  Mg: "mg",
  Mt: "mt",
  Mr: "mr",
  Ms: "ms",
  Ml: "ml",
  Mi: "mi",
  Mk: "mk",
  Mn: "mn",
  Bn: "bn",
  My: "my",
  Mww: "mww",
  Hmn: "hmn",
  Xh: "xh",
  Zu: "zu",
  Ne: "ne",
  No: "no",
  Pa: "pa",
  Ps: "ps",
  Pt: "pt",
  Ny: "ny",
  Ja: "ja",
  Sv: "sv",
  SrLatn: "sr-Latn",
  SrCyrl: "sr-Cyrl",
  St: "st",
  Sm: "sm",
  Si: "si",
  Eo: "eo",
  Sk: "sk",
  Sl: "sl",
  Sw: "sw",
  Gd: "gd",
  So: "so",
  Ceb: "ceb",
  Te: "te",
  Ta: "ta",
  Th: "th",
  Tg: "tg",
  Tr: "tr",
  Cy: "cy",
  ZhLzh: "zh-lzh",
  Ur: "ur",
  Uk: "uk",
  Uz: "uz",
  Haw: "haw",
  Es: "es",
  He: "he",
  El: "el",
  Sd: "sd",
  Hu: "hu",
  Sn: "sn",
  Hy: "hy",
  Ig: "ig",
  It: "it",
  Yi: "yi",
  Hi: "hi",
  Id: "id",
  En: "en",
  Su: "su",
  Jw: "jw",
  Yua: "yua",
  Yo: "yo",
  Vi: "vi",
  ZhCHS: "zh-CHS",
  ZhCHT: "zh-CHT",
} as const;
/**
 * 目标语言代码。请从支持的语言列表中选择一个语言代码。
 */
export type PostTranslateTextToLang = ClosedEnum<
  typeof PostTranslateTextToLang
>;

export const PostTranslateTextToLang$zodSchema = z.enum([
  "sq",
  "ga",
  "et",
  "ar",
  "am",
  "az",
  "be",
  "bg",
  "eu",
  "is",
  "pl",
  "bs-Latn",
  "fa",
  "da",
  "de",
  "ru",
  "fr",
  "tl",
  "fi",
  "fy",
  "km",
  "ka",
  "gu",
  "ht",
  "ko",
  "ha",
  "kk",
  "nl",
  "gl",
  "ca",
  "cs",
  "ky",
  "kn",
  "tlh",
  "hr",
  "otq",
  "co",
  "ku",
  "la",
  "lo",
  "lv",
  "lt",
  "ro",
  "lb",
  "mg",
  "mt",
  "mr",
  "ms",
  "ml",
  "mi",
  "mk",
  "mn",
  "bn",
  "my",
  "mww",
  "hmn",
  "xh",
  "zu",
  "ne",
  "no",
  "pa",
  "ps",
  "pt",
  "ny",
  "ja",
  "sv",
  "sr-Latn",
  "sr-Cyrl",
  "st",
  "sm",
  "si",
  "eo",
  "sk",
  "sl",
  "sw",
  "gd",
  "so",
  "ceb",
  "te",
  "ta",
  "th",
  "tg",
  "tr",
  "cy",
  "zh-lzh",
  "ur",
  "uk",
  "uz",
  "haw",
  "es",
  "he",
  "el",
  "sd",
  "hu",
  "sn",
  "hy",
  "ig",
  "it",
  "yi",
  "hi",
  "id",
  "en",
  "su",
  "jw",
  "yua",
  "yo",
  "vi",
  "zh-CHS",
  "zh-CHT",
]).describe("目标语言代码。请从支持的语言列表中选择一个语言代码。");

/**
 * 包含待翻译文本的JSON对象
 */
export type PostTranslateTextRequestBody = { text: string };

export const PostTranslateTextRequestBody$zodSchema: z.ZodType<
  PostTranslateTextRequestBody
> = z.object({
  text: z.string(),
}).describe("包含待翻译文本的JSON对象");

export type PostTranslateTextRequest = {
  to_lang: PostTranslateTextToLang;
  body: PostTranslateTextRequestBody;
};

export const PostTranslateTextRequest$zodSchema: z.ZodType<
  PostTranslateTextRequest
> = z.object({
  body: z.lazy(() => PostTranslateTextRequestBody$zodSchema),
  to_lang: PostTranslateTextToLang$zodSchema,
});

export type PostTranslateTextInternalServerErrorDetails = {};

export const PostTranslateTextInternalServerErrorDetails$zodSchema: z.ZodType<
  PostTranslateTextInternalServerErrorDetails
> = z.object({});

/**
 * 翻译失败
 */
export type PostTranslateTextInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: PostTranslateTextInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const PostTranslateTextInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostTranslateTextInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => PostTranslateTextInternalServerErrorDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("翻译失败");

export type PostTranslateTextBadRequestDetails = {};

export const PostTranslateTextBadRequestDetails$zodSchema: z.ZodType<
  PostTranslateTextBadRequestDetails
> = z.object({});

/**
 * 无效的请求体
 */
export type PostTranslateTextBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTranslateTextBadRequestDetails | undefined;
  message?: string | undefined;
};

export const PostTranslateTextBadRequestResponseBody$zodSchema: z.ZodType<
  PostTranslateTextBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTranslateTextBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("无效的请求体");

/**
 * 成功响应
 */
export type PostTranslateTextResponseBody = {
  source_lang?: string | undefined;
  translated_text?: string | undefined;
};

export const PostTranslateTextResponseBody$zodSchema: z.ZodType<
  PostTranslateTextResponseBody
> = z.object({
  source_lang: z.string().optional(),
  translated_text: z.string().optional(),
}).describe("成功响应");

export type PostTranslateTextResponse =
  | PostTranslateTextResponseBody
  | PostTranslateTextBadRequestResponseBody
  | PostTranslateTextInternalServerErrorResponseBody;

export const PostTranslateTextResponse$zodSchema: z.ZodType<
  PostTranslateTextResponse
> = z.union([
  z.lazy(() => PostTranslateTextResponseBody$zodSchema),
  z.lazy(() => PostTranslateTextBadRequestResponseBody$zodSchema),
  z.lazy(() => PostTranslateTextInternalServerErrorResponseBody$zodSchema),
]);
